import registerWebComponent from '@boschebike/ebds-js/dist-esm/helpers/registerWebComponent.js';

const STATES = {
  WAITING: 1,
  IDLE: 2,
  MAINTENANCE: 2,
  ERRORED: 4,
};

const MINIMUM_LOADING_SPINNER_VISIBLE = 2000; // 2 seconds
const MINIMUM_LOADING_SPINNER_TO_VISIBLE = 500; // .5 second
const MAXIMUM_TIME_TO_SHOW = 20000; // 20 seconds

class DodoServiceInclude extends HTMLElement {
  #state = STATES.WAITING;

  #initTime;

  constructor() {
    super();
    this.initTime = Date.now();
  }

  onIdle() {
    if (this.state === STATES.MAINTENANCE) {
      return;
    }

    this.state = STATES.IDLE;
    const timeSpent = Date.now() - this.initTime;
    let hideIn = 0;
    if (timeSpent > MINIMUM_LOADING_SPINNER_TO_VISIBLE) {
      hideIn = MINIMUM_LOADING_SPINNER_VISIBLE - timeSpent;
    }
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.classList.remove('dodo-service-include--loading');
      });
    }, hideIn);
  }

  onMaintenance() {
    this.state = STATES.MAINTENANCE;
    this.classList.add('dodo-service-include--maintenance');
    this.classList.remove('dodo-service-include--loading');
  }

  onTimeoutVisible() {
    this.classList.add('dodo-service-include--with-spinner');
  }

  onError() {
    if (this.state !== STATES.WAITING) {
      return;
    }

    this.state = STATES.ERRORED;
    this.classList.add('dodo-service-include--errored');
    this.classList.remove('dodo-service-include--loading');
    console.error(new Error('Could not render micro frontend. Error shown.'));
  }

  connectedCallback() {
    this.addEventListener('idle', this.onIdle);
    this.addEventListener('maintenance', this.onMaintenance);

    setTimeout(() => {
      this.onTimeoutVisible();
    }, MINIMUM_LOADING_SPINNER_TO_VISIBLE);

    setTimeout(() => {
      this.onError();
    }, MAXIMUM_TIME_TO_SHOW);
  }

  disconnectedCallback() {
    console.log('disconnect');
    this.removeEventListener('idle', this.onIdle);
    this.removeEventListener('maintenance', this.onMaintenance);
  }
}

export const registerAll = () => {
  registerWebComponent('dodo-service-include', DodoServiceInclude);
};
